"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseAllWithLimit = exports.bindMockClassFunctions = exports.timeoutHelperFunc = exports.bindClassFunctions = void 0;
var p_limit_1 = __importDefault(require("p-limit"));
var bindClassFunctions = function (classInstance) {
    var e_1, _a;
    try {
        for (var _b = __values(Object.getOwnPropertyNames(Object.getPrototypeOf(classInstance))), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (typeof classInstance[key] === 'function') {
                classInstance[key] = classInstance[key].bind(classInstance);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
exports.bindClassFunctions = bindClassFunctions;
var timeoutHelperFunc = function (time, response) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(response);
        }, time);
    });
};
exports.timeoutHelperFunc = timeoutHelperFunc;
var bindMockClassFunctions = function (classInstance) {
    var e_2, _a;
    try {
        for (var _b = __values(Object.getOwnPropertyNames(Object.getPrototypeOf(classInstance))), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (typeof classInstance[key] === 'function') {
                classInstance[key] = jest.fn(classInstance[key].bind(classInstance));
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
exports.bindMockClassFunctions = bindMockClassFunctions;
var promiseAllWithLimit = function (promises, maxLimit) {
    var limit = (0, p_limit_1.default)(maxLimit);
    var limitedPromises = promises.map(function (promise) { return limit(function () { return promise; }); });
    return Promise.all(limitedPromises);
};
exports.promiseAllWithLimit = promiseAllWithLimit;
